








import { Component, Vue } from 'vue-property-decorator';
import layout from '@/layouts/basic-layout.vue';
import ChangePasswordForm from '@/components/change-password-form.vue';

@Component({
    components: {
        layout,
        'change-password-form': ChangePasswordForm,
    },
})
export default class Home extends Vue {}
